async function getBusinessDetail(businessId) {
  const responsePromise = await fetch('/businessDetail.json');
  return responsePromise.json();
}

export default getBusinessDetail;